<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
          <div class="searchListWrap" v-if="firstDataSet">
            <div class="searchList">
              <div class="scarItemWrap scarHook" v-for="(scarInfo, s) in this.scarArray" :key="'A' + s">
                <div class="scarItem">
                  <p>수술명: <b class="sugery">{{scarInfo.surgeryName}}</b></p>
                  <p>수술일정: <b class="date">{{scarInfo.surgeryDate | moment('YYYY-MM-DD')}}</b></p>
                </div>
                <div class="actionButton" @click="selectedScarItem(s)">
                  <button type="button" >흉터관리</button>
                </div>
              </div>
            <div class="scarItemWrap scarHook enrollment" v-for="(surgeryInfo, d) in this.dataArray" :key="'B' + d">
              <div class="scarItem">
                <p>수술명: <b class="surgery">{{surgeryInfo.surgeryName}}</b></p>
                <p>수술일정: <b class="date">{{surgeryInfo.surgeryDate | moment('YYYY-MM-DD')}}</b></p>
              </div>
              <div class="actionButton" @click="applyScar(d)">
                <button type="button">흉터관리 등록하기</button>
              </div>
            </div>
            </div>
          </div>
            <div v-else>
              <div class="searchListWrap">
                <div class="searchList">
              <div class="listEmpty emptyList">
                <div class="imgWrap">
                  <img src="@/assets/images/error.svg">
                </div>
                <div class="ct_content">
                  <p>수술기록이 없습니다. </p>
                  <p>흉터관리는 수술 후 입력할 수 있습니다.</p>
                </div>
              </div>
              </div>
              </div>
            </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet" @causeAction="addScarGrid()" />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '흉터관리',
        prevUrl: '/'
      },
      imgList: [],
      dateStart: '',
      dateEnd: '',
      IsWhole: '',
      monthDate: '',
      yesterDay: '',
      today: '',
      beginDay: '',
      dateMutated: '',
      firstDataSet: false,
      dataArray: [],
      scarArray: [],
      surgeryCode: '',
      orderParam: '',
      setCount: false
    }
  },
  computed: {
    ...mapGetters([
      'getSurgeryList',
      'GET_SCARINFO_LIST'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_SURGERY_DONE',
      'SET_SURGERY_CODE'
    ]),
    ...mapActions([
      'SURGERY_LIST',
      'FETCH_SCARINFO',
      'APPLY_SCAR'
    ]),
    selectedScarItem (order) {
      const code = this.GET_SCARINFO_LIST[order].scarInfoCode
      this.$router.push(`/scar/scarDetail/${code}`)
    },
    callDateSearch () {
      this.$store.commit('SET_SURGERY_DONE', true)
      this.$router.push('/surgery/surgeryReservationDate')
    },
    async getSurgeryData () {
      try {
        const requestData = {
          // 이번년도 1일부터 오늘 이전 1일까지
          gte: null,
          lte: null,
          default: true
        }
        console.log('전체 데이터셋 호출: ', requestData)
        await this.SURGERY_LIST(requestData)
      } catch (error) {
        console.log('error :', error);
        console.log('수술일정 리스트 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async getScarData () {
      try {
        await this.FETCH_SCARINFO()
      } catch (error) {
        console.log('error :', error);
        console.log('흉터관리 리스트 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    applyScar (order) {
      this.surgeryCode = this.dataArray[order].surgeryCode
      this.orderParam = order
      this.SET_POPUP(true)
      this.popupSet.modalImg = ''
      this.popupSet.content =
        '<p class="red custom-re">개인정보수집 동의</p>' +
        '<p>업로드한 흉터ㆍ관리 사진이</p>' +
        '<p>본인의 것임을 인지하고 그 사진들을</p>' +
        "<p>'땡큐 이비인후과' 가 연구ㆍ홍보 목적으로 </p>" +
        '<p>사용하는 것에 동의합니다.</p>'
      this.popupSet.count = 'causeActionCancelBtn'
      this.popupSet.cancelBtnText = '취소'
    },
    viewTrans () {
      this.removeA(this.dataArray, this.dataArray[this.orderParam])
    },
    async addScarGrid () {
      try {
        const applySurgeryCode = this.surgeryCode
        const requestData = {
          surgeryCode: applySurgeryCode,
          scarInfoCode: null
        }
        await this.APPLY_SCAR(requestData)
          .then(() => {
            this.viewTrans()
            this.dataInit()
            this.SET_POPUP(false)
            this.SET_POPUP(true)
            this.popupSet.content = '흉터관리로 등록되었습니다.'
            this.popupSet.count = 'single'
          })
      } catch (error) {
        console.log('error :', error);
        console.log('흉터관리 등록 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    carryData () {
      console.log('서저리리스트', this.getSurgeryList)
      console.log('흉터리스트', this.GET_SCARINFO_LIST)
      // 흉터 , 수술리스트 모두 비었다면
      if ((this.getSurgeryList.length < 1) && (this.GET_SCARINFO_LIST.length < 1)) {
        this.firstDataSet = false
      }
      // 흉터리스트 채우기
      if (this.GET_SCARINFO_LIST.length >= 1) {
        this.firstDataSet = true
        this.scarArray = []
        const scarArray = []
        for (let i = 0; i < this.GET_SCARINFO_LIST.length; i++) {
          scarArray.push(this.GET_SCARINFO_LIST[i])
        }
        this.scarArray = scarArray
      }
      // 수술완료 리스트 채우기
      if (this.getSurgeryList.length >= 1) {
        this.firstDataSet = true
        this.dataArray = []
        const surgeryArray = []
        const surgeryArray2 = []
        for (let i = 0; i < this.getSurgeryList.length; i++) {
          if (this.getSurgeryList[i].state === '완료') {
            surgeryArray.push(this.getSurgeryList[i])
            surgeryArray2.push(this.getSurgeryList[i])
          }
        }
        console.log('수술완료 리스트', surgeryArray)
        for (let j = 0; j < surgeryArray.length; j++) {
          for (let k = 0; k < this.scarArray.length; k++) {
            if (surgeryArray[j].surgeryCode === this.scarArray[k].surgeryCode) {
              this.removeA(surgeryArray2, surgeryArray[j])
            }
          /*  if (surgeryArray[j].surgeryCode === this.scarArray[k].surgeryCode) {
              this.removeA(surgeryArray, surgeryArray[j])
            } */
          }
        }
        console.log('정한 것', surgeryArray2)
        this.dataArray = surgeryArray2
      }
    },
    // 중복 배열제거
    removeDuplicatesArray (arr) {
      const tempArr = []
      for (let i = 0; i < arr.length; i++) {
        if (tempArr.length === 0) {
          tempArr.push(arr[i])
        } else {
          let duplicatesFlag = true
          for (let j = 0; j < tempArr.length; j++) {
            if (tempArr[j] === arr[i]) {
              duplicatesFlag = false
              break
            }
          }
          if (duplicatesFlag) {
            tempArr.push(arr[i])
          }
        }
      }
      console.log('ttf', tempArr)
      return tempArr
    },
    removeA (arr) {
      let what
      const a = arguments
      let L = a.length
      let ax
      while (L > 1 && arr.length) {
        what = a[--L]
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1)
        }
      }
      return arr
    },
    async dataInit () {
      await this.getSurgeryData()
      await this.getScarData()
      this.carryData()
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.dataInit()
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
  .searchListWrap {
    &.replace {
      h5.period {
      }
    }
    &.bone {
      padding:20px 0;
    }
    .surgeryItemWrap, .scarItemWrap {
      &.enrollment {
        .actionButton {
          &:hover {
            button {
              background:rgba(101, 218, 255, 0.8) !important;
            }
          }
          button {
            background: #65daff !important;
          }
        }
      }
      &.scarHook {
        .scarItem {
          padding:20px;
          p {
            color:#fff;
            font-family: NotoSansCJKkr;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: center;
          }
        }
        .actionButton {
          &:hover {
            button {
              background:rgba(255, 101, 101, 0.8);
            }
          }
          button {
            background: #ff6565;
          }
        }
      }
      .surgeryItem, .scarItem {
        &:last-of-type {
          margin:0 auto;
        }
        p {
          font-family: NotoSansCJKkr;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
        }
      }
      .actionButton {
        text-align:center;
       button {
         cursor:pointer;
         font-family: NotoSansCJKkr;
         font-size: 14px;
         font-weight: normal;
         font-stretch: normal;
         font-style: normal;
         line-height: 40px;
         letter-spacing: normal;
         text-align: center;
         color: #ffffff;
         width:100%;
         border:0;
       }
      }
    }
  }

</style>
